import { IonCol, IonRow } from '@ionic/react';
import React from 'react';
import { useIntl } from 'react-intl';
import { DqText } from '../../../dq-text';
import { JobMessages } from 'src/intl/JobMessages';
import './InformationModals.scss';
import { AppModal } from '../../../reusable-components/app-modal/AppModal';

interface VennDiagramModalProps {
  /**
   * Whether the modal is open.
   */
  isOpen: boolean;
  /**
   * Triggers the request to close the modal.
   */
  onClose: () => void;
  /**
   * Triggers the request to close the modal and submit the edit-profile.
   */
}

export const VennDiagramModal: React.FC<VennDiagramModalProps> = ({ onClose, isOpen }) => {
  const { formatMessage } = useIntl();

  return (
    <AppModal
      isOpen={isOpen}
      onClose={onClose}
      title={formatMessage(JobMessages.vennDiagramHeading)}
      primaryButton={{
        label: formatMessage(JobMessages.gotItButton),
        onClick: onClose,
      }}
    >
      <IonRow className="info-heading-row">
        <DqText variant="body-strong"> {formatMessage(JobMessages.overviewHeading)}</DqText>
      </IonRow>
      <IonRow className="ion-padding-bottom">
        <DqText variant="body">{formatMessage(JobMessages.vennDiagramOverviewDescription)}</DqText>
      </IonRow>
      <IonRow>
        <IonCol size="1" offset="1">
          <div className="dot hp-blue" />
        </IonCol>
        <IonCol size="10">
          <DqText variant="body-strong">{formatMessage(JobMessages.vennDiagramLegendHighPressure)}</DqText>
        </IonCol>
      </IonRow>
      <IonRow>
        <IonCol size="1" offset="1">
          <div className="dot idle-yellow" />
        </IonCol>
        <IonCol size="10">
          <DqText variant="body-strong">{formatMessage(JobMessages.vennDiagramLegendHighIdleOff)}</DqText>
        </IonCol>
      </IonRow>
      <IonRow>
        <IonCol size="1" offset="1">
          <div className="dot overlap-green" />
        </IonCol>
        <IonCol size="10">
          <DqText variant="body-strong">{formatMessage(JobMessages.vennDiagramLegendOverlap)}</DqText>
        </IonCol>
      </IonRow>
      <IonRow className="info-heading-row">
        <DqText variant="body-strong"> {formatMessage(JobMessages.insightsHeading)}</DqText>
      </IonRow>
      <ul>
        <li>
          <DqText variant="body">{formatMessage(JobMessages.vennDiagramInsightDescription)}</DqText>
        </li>
        <ul>
          <DqText variant="body">{formatMessage(JobMessages.vennDiagramInsightDescriptionBullet)}</DqText>
        </ul>
      </ul>
    </AppModal>
  );
};

export default VennDiagramModal;
